module.exports = __webpack_public_path__ + "media/images/claret-jug2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/claret-jug2.jpg
// module id = 65
// module chunks = 0